module.exports = __webpack_public_path__ + "img/menuicon-102.82748ddc.png";